import type { ReactNode } from "react";
import { useTabsContext } from "./useTabsContext";

interface TabsContentProps {
  value: string;
  children: ReactNode;
}

export function TabsContent({ value, children }: TabsContentProps) {
  const { activeValue, idPrefix } = useTabsContext();
  if (value !== activeValue) return null;

  return (
    <div
      role="tabpanel"
      id={`${idPrefix}-panel-${value}`}
      aria-labelledby={`${idPrefix}-trigger-${value}`}
    >
      {children}
    </div>
  );
}
